module.exports = "/images/user-remove-red.svg?8fde479161c0e4afac53a9233877cdc3";